// browser-based only
// unescapes entities such as &amp; &lt; &gt; &#8202;
export const unescapeHtmlEntities = str => {
  const doc = new DOMParser().parseFromString(str || '', 'text/html');
  return doc.documentElement.textContent;
};

// remove leading, trailing, and repeated whitespace
// and convert all whitespace chars (eg. \u2009, \t, \n) into regular " "
// see: http://en.wikipedia.org/wiki/Whitespace_character
export const condenseAndNormalizeWhitespaces = str => (str || '').trim().replace(/\s+/g, ' ');

// Remove non-printable ASCII chars http://en.wikipedia.org/wiki/ASCII#ASCII_printable_characters
export const removeNonASCII = str => (str || '').replace(/[^\x20-\x7E]/g, '');
//# sourceMappingURL=normalize-string.js.map